// https://tkrisk.pgm-np.spglobal.com/docs/graph_creation/nodes_definition.html#expression-reference-for-deterministic-nodes
const MATH_FUNCTION_KEYWORDS = [
  "sqrt",
  "abs",
  "log10",
  "log",
  "sin",
  "cos",
  "sinh",
  "cosh",
  "tanh",
  "arcsin",
  "arccos",
  "arctan",
  "arcsinh",
  "arccosh",
  "arctanh",
  "exp",
  "expm1",
  "log1p",
  "arctan2",
  "MIN",
  "MAX",
] as const

export const LOGIC_FUNCTION_KEYWORDS = ["IF", "IFS", "AND", "OR"] as const

export const EXPRESSION_RESERVED_KEYWORDS = [
  ...MATH_FUNCTION_KEYWORDS,
  ...LOGIC_FUNCTION_KEYWORDS,
] as const

const DISTRIBUTION_RESERVED_KEYWORDS = [
  "distribution",
  "ubound",
  "lbound",
  "a",
  "b",
  "c",
  "loc",
  "scale",
  "df",
  "dfn",
  "dfd",
  "kappa",
  "mu",
  "n",
  "p",
  "M",
  "N",
  "s",
  "nc",
] as const

const EVIEWS_RESERVED_KEYWORDS = [
  "%",
  "abs",
  "and",
  "ar",
  "c",
  "cnorm",
  "com1",
  "com2",
  "con",
  "cos",
  "d",
  "dlog",
  "dnorm",
  "else",
  "endif",
  "exp",
  "garch",
  "log",
  "logit",
  "lpt1",
  "lpt2",
  "ma",
  "na",
  "not",
  "nrnd",
  "or",
  "prn",
  "resid",
  "rnd",
  "sar",
  "sin",
  "sma",
  "sqr",
  "then",
  "untitled",
]

// reserved keywords for node labels, table columns / rows names, category names
const NODE_RESERVED_KEYWORDS = [
  ...MATH_FUNCTION_KEYWORDS,
  ...LOGIC_FUNCTION_KEYWORDS,
  ...DISTRIBUTION_RESERVED_KEYWORDS,
  ...EVIEWS_RESERVED_KEYWORDS,
  "index",
  "columns",
  "rows",
  "inf",
  "value_x",
  "value_y",
  "value",
  "floor",
  "ceil",
  "at",
  "__at__",
  "continuous",
  "expression",
  "values",
  "mean",
  "sum",
  "e",
] as const

const nodeReservedKeywordsSet = new Set(
  NODE_RESERVED_KEYWORDS.map((keyword) => keyword.toLowerCase().trim()),
)

export const isNodeReservedKeyword = (value: string): boolean => {
  return nodeReservedKeywordsSet.has(value.toLowerCase().trim())
}
